import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { Accordion, Box, Copy } from '@honda-canada/design-system-react';
import SpecialOffersContext from './SpecialOffersContext';
import themeStyles from './SpecialOfferCard.styles';
const AccordionTitle = themeStyles.apply(Copy, 'AccordionTitle');
const AccordionBodyWrapper = themeStyles.apply(Box, 'AccordionBodyWrapper');
const variantStyleConfig = {
    variant1: { textDecoration: 'underline' },
    variant2: { color: 'blue' },
};
const LegalInfoAccordion = ({ legalDisclaimer, accordionBehaviour }) => {
    var _a;
    const { key, title, contents } = legalDisclaimer;
    const { variant } = useContext(SpecialOffersContext);
    const accordionTitleStyles = (_a = variantStyleConfig[variant]) !== null && _a !== void 0 ? _a : null;
    const items = [
        {
            key,
            title: (_jsx(AccordionTitle, { "data-testid": "cy-special-offer-legal-disclaimer-title", accordionTitleStyles: accordionTitleStyles, size: "legal", children: title })),
            content: (_jsx(AccordionBodyWrapper, { "data-testid": "cy-special-offer-legal-disclaimer-content", children: contents.map(({ key: contentKey, text, order }, index) => (_jsxs(Copy, { size: "legal", children: [_jsx(Copy, { as: "span", size: "legal", "data-testid": `cy-special-offer-legal-disclaimer-superscipt-${index + 1}`, children: order }), ' ', _jsx(Copy, { as: "span", size: "legal", "data-testid": `cy-special-offer-legal-disclaimer-text-${index + 1}`, children: text })] }, contentKey))) })),
        },
    ];
    return (_jsx(Accordion, { items: items, behaviour: accordionBehaviour, iconName: "animatedArrowUpDown", borderColor: "transparent", panelBackgroundColor: "grey.4" }));
};
export default LegalInfoAccordion;
